import type { InferOutput } from 'valibot';
import * as v from 'valibot';

const voidType = v.pipe(v.void_(), v.brand('Void'));

export type Void = InferOutput<typeof voidType>;
